var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"appContainer",attrs:{"id":"app"}},[_c('transition',{attrs:{"name":"header-fade"}},[(_vm.showHeader)?_c('Header',{key:"header",class:{
        active: _vm.showHeader,
        normal: _vm.prevScrollPos == 0 && _vm.showHeader,
      }}):_vm._e()],1),_vm._v(" "),_c('router-view')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1caa1041","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = null
// module chunks = 